<template>
  <form @submit.prevent="onSubmit">
    <div class="wizard-header">
      <h3 class="wizard-title">{{ wizardTitle }}</h3>
      <p class="category">{{ wizardDescription }}</p>
    </div>

      <insurers></insurers>


    <wizard-navigation :step="step"></wizard-navigation>

    <div class="tab-content details-tab-content">
      <div
        class="tab-pane"
        v-bind:class="{ active: step == 4 }"
        v-if="step == 4"
      >
        <error-message></error-message>

        <div class="row">
          <div class="col-sm-12">
            <h5 class="info-text">{{ infoText }}</h5>
          </div>
        </div>

        <div class="row">
          <div
            class="col-sm-12"
            v-for="(groupedQuestions, questionGroupKey) in questions"
            :key="questionGroupKey"
            v-if="questionGroupKey !== 'no_group'"
          >
            <h5 class="info-text">
              {{
                questionGroupKey.charAt(0).toUpperCase() +
                questionGroupKey.slice(1)
              }}
            </h5>
            <question
              v-for="(question, index) in groupedQuestions"
              :key="question.id"
              v-bind:ref="'question' + question.id"
              :id="index + 1"
              :data="question.body"
              :choice="String(fields[question.field_tag])"
              :error="errors.indexOf(question.field_tag) !== -1"
              v-on:change="handleQuestionChange(question, $event)"
            />
          </div>

          <div
            class="col-sm-12"
            v-for="(groupedQuestions, questionGroupKey) in questions"
            :key="questionGroupKey"
            v-if="questionGroupKey == 'no_group'"
          >
            <h5 class="info-text" v-if="Object.keys(questions).length > 1">
              Other questions
            </h5>
            <question
              v-for="(question, index) in groupedQuestions"
              :key="question.id"
              v-bind:ref="'question' + question.id"
              :id="index + 1"
              :data="question.body"
              :choice="String(fields[question.field_tag])"
              :error="errors.indexOf(question.field_tag) !== -1"
              v-on:change="handleQuestionChange(question, $event)"
            />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-10 col-sm-offset-1">
            <div class="alert alert-simple">
              <div class="row">
                <div class="col-md-12">
                  <b>I have read, understood and agree to the following:</b>
                  <ul class="pl-15 mt-15">
                    
                    <li v-if="underwriter.product_liability_policy">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="underwriter.product_liability_policy"
                      >
                        Policy Wording
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="dutyOfDisclosureUrl"
                        >Duty of Disclosure</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="payByTheMonthUrl"
                        >Pay By The Month</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="termsAndConditionsUrl"
                        >Terms & Conditions</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="generalAdviceWarning"
                        >General Advice Warning</a
                      >
                    </li>
                    <!-- <li v-if="accidentCover">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="accidentCoverPDS"
                        >Accident Cover PDS & Policy Wording</a
                      >
                    </li> -->
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="letterOfAppointmentUrl"
                        >Letter Of Appointment</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="letterOfEngagementUrl"
                        >Letter Of Engagement</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="fsgPdfUrl"
                        >Financial Services Guide and Privacy Policy</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-md-6 text-center">
                  <div class="form-group mt-15 mb-0">
                    <div class="btn-group push-15 btn-group-justified">
                      <div class="btn-group">
                        <button
                          type="button"
                          :class="{
                            'btn btn-sm b-r-0': true,
                            'btn-selected btn-fill': fields.terms == true,
                          }"
                          @click="fields.terms = true"
                        >
                          Yes
                        </button>
                      </div>
                      <div class="btn-group">
                        <button
                          type="button"
                          :class="{
                            'btn btn-sm': true,
                            'btn-selected btn-fill': fields.terms == false,
                          }"
                          @click="fields.terms = false"
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wizard-footer" style="padding-top: 20px">
      <div class="clearfix"></div>
      <div class="pull-right">
        <button
          class="btn btn-next btn-fill btn-success btn-wd"
          type="button"
          @click="submitForm"
          :disabled="disabledNextBtn"
        >
          Proceed to Checkout <i class="fa fa-arrow-right"></i>
        </button>
      </div>
      <div class="pull-left">
        <button
          class="btn btn-previous btn-default btn-wd"
          type="button"
          @click="previousClicked"
        >
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <div
        class="pull-right pull-right p-t-10 m-r-10 text-center"
        v-if="disabledNextBtn"
      >
        <label>Please answer ALL questions to proceed</label>
      </div>
      <div class="clearfix"></div>
    </div>
  </form>
</template>

<script>
import { filter, omit, isNil, get } from "lodash";
import { mapActions, mapMutations } from "vuex";
import { mapState } from "vuex";
import store from "../store";
import * as appConfigs from "../configs";
import Cookies from "js-cookie";
import { generateErrorMessage } from "../helpers";
import WizardNavigation from "./WizardNavigation";

export default {
  store,
  props: {
    wizardTitle: {
      type: String,
      required: true,
    },
    wizardDescription: {
      type: String,
      required: true,
    },
    infoText: {
      type: String,
      required: true,
    },
  },
  components: {
    WizardNavigation,
  },
  data: function () {
    return {
      step: 4,
      fields: {
        terms: null,
      },
      questions: [],
      errors: [],
    };
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      accidentCover: (state) => state.accidentCover,
      underwriter: (state) => state.underwriter,
      pendingOrder: (state) => state.pendingOrder,
    }),
    pendingOrderId() {
      return Cookies.get("pendingOrderId") || this.pendingOrder?.id;
    },
    hasWrongAnswer() {
      return this.updateErrors().length > 0;
    },
    disabledNextBtn() {
      return Boolean(
        !this.fields.terms ||
          Object.keys(this.fields).some((field) => isNil(this.fields[field]))
      );
    },
    fsgPdfUrl() {
      return appConfigs.fsgPdfUrl;
    },
    dutyOfDisclosureUrl() {
      return appConfigs.dutyOfDisclosureUrl;
    },
    payByTheMonthUrl() {
      return appConfigs.payByTheMonthUrl;
    },
    termsAndConditionsUrl() {
      return appConfigs.termsAndConditionsUrl;
    },
    generalAdviceWarning() {
      return appConfigs.generalAdviceWarning;
    },
    accidentCoverPDS() {
      return appConfigs.accidentCoverPDS;
    },
    letterOfAppointmentUrl() {
      return appConfigs.getAppointmentLetterUrl + "/" + this.pendingOrderId;
    },
    letterOfEngagementUrl() {
      return appConfigs.letterOfEngagement; 
    },
  },
  watch: {
    hasWrongAnswer(quoteRejected) {
      this.$store.commit("setQuoteRejected", { quoteRejected });
    },
  },
  mounted() {
    this.dataLoad();
    this.$root.$on("gotostep", this.handleGotostep);
  },
  beforeDestroy() {
    this.$root.$off("gotostep", this.handleGotostep);
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      loadQuestions: "loadQuestions",
      calculate: "calculate",
    }),
    ...mapMutations({
      updateStateByPostcode: "updateStateByPostcode",
    }),
    handleGotostep(step) {
      if (step < this.step) {
        this.$store.commit("setQuoteRejected", { quoteRejected: false });
        this.fields = { terms: null };
      }
    },
    updateErrors() {
      var filledAnswers = {};

      for (var key in this.questions) {
        var answers = this.questions[key].reduce((d, question) => {
          d[question.field_tag] = question.answer;
          return d;
        }, {});

        for (var k in answers) {
          filledAnswers[k] = answers[k];
        }
      }

      this.errors = Object.keys(omit(this.fields, ["terms"])).filter(
        (field) =>
          !isNil(this.fields[field]) &&
          this.fields[field] != filledAnswers[field]
      );

      return this.errors;
    },
    previousClicked() {
      this.$store.commit("decrementStep");
      this.$store.commit("clearError");
      this.$store.commit("setQuoteRejected", { quoteRejected: false });
      this.fields = { terms: null };
      this.scrollToTop();
    },
    handleQuestionChange(question, value) {
      const fieldName = question.field_tag;
      this.fields[fieldName] = value;
      this.updateErrors();

      if (this.errors.indexOf(fieldName) === -1) {
        let nextQuestion = null;
        for (var key in this.questions) {
          for (let i = 0; i < this.questions[key].length; i++) {
            if (question.id === this.questions[key][i].id) {
              nextQuestion = this.questions[key][++i];
              break;
            }
          }
        }

        if (nextQuestion) {
          const component = this.$refs[`question${nextQuestion.id}`][0];
          if (component) {
            component.scrollTo();
          }
        } else {
          $("html, body").animate(
            { scrollTop: document.documentElement.scrollTop + 200 },
            "500"
          );
        }
      }
    },
    submitForm() {
      this.$store.commit("setScreenLoader", { showScreenLoader: true });
      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          in_referral: this.hasWrongAnswer,
          step: this.step,
          id: this.pendingOrderId,
        })
        .then((response) => {
          const pendingOrder = get(
            response,
            "data.data.pendingOrder",
            this.pendingOrder
          );
          this.$store.commit("clearError");
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setPendingOrder", { pendingOrder });
          if (pendingOrder.in_referral) {
            Cookies.remove("pendingOrderId");
            this.$store.commit("resetState");
          } else {
            this.$store.commit("incrementStep");
          }
          this.scrollToTop();
        })
        .catch((error) => {
          let errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
    dataLoad() {
      if (!this.pendingOrderId) {
        return;
      }

      const orderId = this.pendingOrderId;

      if (orderId == undefined || orderId == null) {
        return;
      }

      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      this.loadPendingOrder({ orderId })
        .then((data) => {
          const fields = {
            ...this.fields,
            ...data,
          };

          return Promise.all([
            this.loadQuestions(fields),
            this.calculate(fields),
          ])
            .then(([questions, summaryData]) => {
              this.$store.commit("setScreenLoader", {
                showScreenLoader: false,
              });
              this.$store.commit("setSummaryData", { summaryData });
              this.updateStateByPostcode({
                stateByPostcode: summaryData.state,
              });
              this.questions = questions;

              const questionAnswers = data.questionAnswers;
              var questionsFields = {};
              for (var key in questions) {
                const f = questions[key].reduce((val, question) => {
                  let choice = questionAnswers[question.field_tag]
                    ? questionAnswers[question.field_tag].pivot.answer
                    : undefined;

                  val[question.field_tag] = choice;
                  return val;
                }, {});

                for (var k in f) {
                  questionsFields[k] = f[k];
                }
              }

              this.fields = {
                ...this.fields,
                ...questionsFields,
              };
            })
            .catch(() => {
              this.$store.commit("setScreenLoader", {
                showScreenLoader: false,
              });
            });
        })
        .catch(() => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/form/global";

.pl-15 {
  padding-left: 15px;
}
.mt-15 {
  margin-top: 15px;
}
.mt-0 {
  margin-top: 0;
}
.b-r-0 {
  border-right: 0;
}
.btn-previous{
  border-radius: 5px !important;
}
</style>
